import { combineReducers } from "redux";
import getSnapShotReducer from "./getSnapshotInfoReducer";

const SnapShotReducer = combineReducers({
    snapShotInfo: getSnapShotReducer

});

export default SnapShotReducer;
